/**
 * Format a magazine breakdown as a compact "2+5" string for display next
 * to a shot count. Returns null when there's no meaningful split (no
 * breakdown, or a single magazine) so callers can omit the suffix.
 */
export function formatMagazines(
  magazines: ReadonlyArray<{ shots: number }> | null | undefined,
): string | null {
  if (!magazines || magazines.length <= 1) return null;
  return magazines.map((m) => m.shots).join('+');
}
